import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { ListChecks, CheckCircle2 } from "lucide-react";

const PRIO = { high: "bg-red-100 text-red-700", medium: "bg-amber-100 text-amber-800", low: "bg-stone-200 text-stone-600" };
const STATUS = { open: "Open", scheduled: "Scheduled", in_progress: "In Progress" };

export default function PortalTasks() {
  const [data, setData] = useState(null);
  const [showDone, setShowDone] = useState(false);
  useEffect(() => { api.get("/portal/tasks").then(({ data }) => setData(data)); }, []);
  if (!data) return <div className="p-6 font-bold uppercase text-sm">Loading tasks…</div>;
  return (
    <div className="space-y-4" data-testid="portal-tasks">
      <div className="bg-white border border-stone-200">
        <div className="bg-[#1F3D34] text-white px-4 py-3 font-bold uppercase text-xs flex items-center gap-2">
          <ListChecks size={15} /> To-Do — from scouting reports ({data.todo.length})
        </div>
        {data.todo.length === 0 && <div className="p-6 text-stone-400 font-bold uppercase text-xs text-center">Nothing outstanding — all caught up</div>}
        <div className="divide-y divide-stone-100">
          {data.todo.map((t) => (
            <div key={t.id} className="p-4 flex flex-wrap items-start justify-between gap-2" data-testid={`portal-task-${t.id}`}>
              <div>
                <div className="font-bold">{t.title}</div>
                <div className="text-xs text-stone-500 mt-0.5">
                  Ranch {t.ranch_number} · {(t.block_labels || []).join(", ")}{t.acres ? ` · ${t.acres} ac` : ""}
                  {t.scheduled_date ? ` · scheduled ${t.scheduled_date}` : t.due_date ? ` · due ${t.due_date}` : ""}
                </div>
                {t.observation_note && <div className="text-xs text-stone-600 mt-1 italic">"{t.observation_note}"</div>}
              </div>
              <div className="flex gap-1.5">
                {t.priority && <span className={`text-[10px] font-bold uppercase px-2 py-1 ${PRIO[t.priority] || PRIO.low}`}>{t.priority}</span>}
                <span className="text-[10px] font-bold uppercase px-2 py-1 bg-sky-100 text-sky-800">{STATUS[t.status] || t.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button data-testid="portal-tasks-toggle-done" onClick={() => setShowDone(!showDone)}
        className="h-10 px-4 border border-stone-300 bg-white font-bold uppercase text-xs flex items-center gap-2">
        <CheckCircle2 size={14} /> {showDone ? "Hide" : "Show"} Completed ({data.done.length})
      </button>
      {showDone && (
        <div className="bg-white border border-stone-200 divide-y divide-stone-100" data-testid="portal-tasks-done">
          {data.done.map((t) => (
            <div key={t.id} className="p-3 text-sm flex justify-between gap-2">
              <span className="text-stone-600">✓ {t.title} — Ranch {t.ranch_number} · {(t.block_labels || []).join(", ")}</span>
              <span className="text-xs text-stone-400 font-mono">{(t.completed_at || "").slice(0, 10)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
